var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('div',{staticClass:"home"},[(_vm.isLogin)?_c('div',[_c('Principal')],1):_c('div',[_c('Login')],1),(false)?_c('Principalv2'):_vm._e()],1),_c('confirm',{ref:"confirm"}),_c('confirm-text',{ref:"confirm_text"}),_c('notify',{ref:"notify"}),_c('AModalConvenio',{ref:"amodalconvenio"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }